module.exports = __webpack_public_path__ + "img/9.a2c60b36.png";